module.exports = __webpack_public_path__ + "img/123.0f584527.jpg";